export enum DataForChange {
    phone = 1,
    email = 2
}